import React from 'react';
import { classes } from '@bloomberg/media-ui-core';

import styles from './styles.module.css';

export const OrSeparator = (props: { theme: 'light' | 'dark' }) => (
  <div className={styles.separatorRow}>
    <div className={styles.separatorItem}>
      <hr />
    </div>
    <div
      className={classes([
        styles.separatorItem,
        { [styles.textWhite]: props.theme === 'dark' },
      ])}
    >
      <span>or</span>
    </div>
    <div className={styles.separatorItem}>
      <hr />
    </div>
  </div>
);
